import React from 'react'
import Table from '../Table'
import classNames from 'classnames'
import checkboxHOC from 'react-table/es/hoc/selectTable'
const CheckboxTable = checkboxHOC(Table)
class SelectTable extends React.PureComponent {
  getInstance() {
    return this.selectableTableRef.getWrappedInstance()
  }
  render() {
    const { checkboxProps,  className, ...others } = this.props

    return (
      <CheckboxTable ref={ r => this.selectableTableRef = r} {...others} {...checkboxProps} className={classNames('pan-checkbox', className) } />
    )
  }
}
export default SelectTable
